import { useRef } from "react";
import { useLocation } from "react-router-dom";
import { useDropdown } from '../../hooks/useDropdown';

import { Button } from "../Shared/Button";
import { TeacherSignedInDropdown } from "./TeacherSignedInDropdown"

import logoSrc from "../../images/Profile-Default.png"

import "./index.css";

function PlusIcon() {
  return (
    <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
      <path d="M13 5C13 4.44772 12.5523 4 12 4C11.4477 4 11 4.44772 11 5V11H5C4.44772 11 4 11.4477 4 12C4 12.5523 4.44772 13 5 13H11V19C11 19.5523 11.4477 20 12 20C12.5523 20 13 19.5523 13 19V13H19C19.5523 13 20 12.5523 20 12C20 11.4477 19.5523 11 19 11H13V5Z" fill="#FCFCFC"/>
    </svg>
  )
}

function TeacherNavbar({ createCourse }) {
  const ref = useRef();
  const { pathname } = useLocation();
  const [showDropdown, setShowDropdown] = useDropdown(ref);

  return (
    <div className="TeacherTractusNavbar">
      <div className="TeacherTractusNavbarLogoContainer">
        <div className="TeacherTractusNavbarLogo" />
      </div>
      <div>
        <div className="TeacherTractusNavbarRight">
          {pathname === "/teacher/dashboard" &&
            <Button
              text="Create Course"
              Icon={() => <PlusIcon />}
              onClick={createCourse}
            />
          }
          <div
            onClick={() => setShowDropdown(!showDropdown)}
            style={{ display: "flex", position: "relative" }}
          >
            <div
              className="TeacherTractusNavbarProfileImg"
              style={{ backgroundImage: `url("${logoSrc}")` }}
            />
            <svg width="10" height="7" viewBox="0 0 10 7" fill="none" xmlns="http://www.w3.org/2000/svg">
              <path fill-rule="evenodd" clip-rule="evenodd" d="M9.29294 0.333374C9.71219 0.333374 9.94528 0.81834 9.68337 1.14572L5.39035 6.512C5.19019 6.7622 4.80965 6.7622 4.60948 6.512L0.316463 1.14572C0.0545568 0.818339 0.287644 0.333374 0.706898 0.333374L9.29294 0.333374Z" fill="#131313"/>
            </svg>
            {showDropdown &&
              <div ref={ref}>
                <TeacherSignedInDropdown />
              </div>
            }
          </div>
        </div>
      </div>
    </div>
  )
}

export default TeacherNavbar
